import application from "stimulus_application";
import { definitionsFromContext } from "stimulus/webpack-helpers";
import "../../global/flatpickr.css";
import "./booking_calendar.css";
import "./booking_calendar_header.css";
import "./booking_calendar_flatpickr.css";

const context = require.context('./', true, /_controller\.js$/);
application.load(definitionsFromContext(context));
